import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import useCountryHook from "@common/hooks/useCountryList.ts";

export interface LegalEntityCountryFieldProps {
    country?: string;
    onChange: (country: string) => void;
    readOnly?: boolean;
    disabled: boolean;
    isLoading: boolean;
    errorText?: string;
}

function LegalEntityCountryField(props: LegalEntityCountryFieldProps) {
    const { translateString } = useTranslation();
    const { selectableCountries, countriesIsLoading } = useCountryHook();

    return (
        <DotLegalSelect
            label={translateString("country")}
            options={selectableCountries}
            selectedItem={props.country ? props.country : null}
            onChange={props.readOnly ? () => {} : (country) => props.onChange(country ?? "")}
            placeholder={translateString("country")}
            noOptionsLabel={translateString("noOptions")}
            isLoading={(countriesIsLoading || props.isLoading) && !props.readOnly}
            disabled={props.disabled}
            errorText={props.errorText}
            disableClearable
        />
    );
}

export default LegalEntityCountryField;
